import { Poker, PokerType } from '@/components/common/poker';
import './index.scss';
import { GameType } from '@/models/games/enums/GameType';

type BetRecordPokerListProps = {
    decks: number[][];
    gameType?: GameType;
};

export const BetRecordPokerList = (props: BetRecordPokerListProps) => {
    const { gameType, decks } = props;

    return (
        <div className="bet-record-poker-list">
            {decks.map((pokers, idx) => (
                <div key={`pokers-${idx}`} className="common-deck">
                    {pokers.map((poker, i) => (
                        <div
                            key={`poker-${i}`}
                            className={`common-poker ${gameType ? `gt-${gameType}` : ''} ${i === pokers.length - 1 ? 'last-card' : ''}`}
                            style={{ zIndex: i }}
                        >
                            <Poker
                                n={poker}
                                type={
                                    i === pokers.length - 1
                                        ? PokerType.Common
                                        : PokerType.AndarBahar1
                                }
                            />
                        </div>
                    ))}
                </div>
            ))}
        </div>
    );
};

export const BJ2BetRecordPokerList = (props: BetRecordPokerListProps) => {
    const { decks } = props;

    return (
        <div className="bj2-bet-record-poker-list">
            {decks.map((pokers, idx) => (
                <div key={`pokers-${idx}`} className="common-deck">
                    {pokers.map((poker, i) => (
                        <div key={`poker-${i}`} className="common-poker">
                            <Poker n={poker} />
                        </div>
                    ))}
                </div>
            ))}
        </div>
    );
};
